export default __webpack_public_path__ + "static/lifeprint-b946abd93eda3f8a9c53e7c3342248d5.png";